import React, {
  useState,
  useRef,
  forwardRef,
  useImperativeHandle,
  useEffect,
  useMemo,
  useCallback
} from "react";
import { useNavigate } from "react-router-dom";
import GolbalSearch from "../utility/common/helpers/GolbalSearch";
import { handleExport1 } from "../utility/data/export/GlobalExport";
import { Row, Col, Container } from "react-bootstrap";
import { ICONS } from "../utility/common/constants/icons";
import { getGridHeaderData,uploadpqrgridfile, deletePQRFile, DeletePQR, UpdatePQRHeader } from "../../Services/pqr-header-service";
import GlobalColumnDefinations, { getHeader_FieldName } from "../utility/grid/definitions/AgGridDefination";
import GridMaster from "../utility/grid/GridMaster";
import Toaster, { showSuccess,showWarning } from "../utility/ui/notifications/Toaster";
import UnifiedActionRenderer from "../utility/grid/renderers/ActionRenderers/UnifiedActionRenderer";
import BarLoader from "react-spinners/BarLoader";
import Pdf_DownloadPQR from "./PDF/Pdf_DownloadPQR";
import Excel_DownloadPQR_GrooveOverlay from "./Excel/Excel_DownloadPQR_GrooveOverlay";
import Excel_DownloadPQR_Tubesheet from "./Excel/Excel_DownloadPQR_Tubesheet";
import { TUBESHEET_COLUMNS, GROOVE_OVERLAY_COLUMNS } from "./config/PQRColumnDefinitions";
import axios from "axios";
import { getPresignedURL, getPresignedURLForPQRRecord } from "../../Services/Welder-services";
import { ImageUploadRenderer } from "../utility/grid/renderers/ActionRenderers/ImageUploadRenderer";


const PQRImageUploadRenderer = ({
  data, folderpqr, Imgloading,
  setLoading, filteredResult, setFilteredResult
}) => {
  const [profile, setProfile] = useState("");
  const [progress, setProgress] = useState(0);
  const [deleteCounter, setDeleteCounter] = useState(0);
  const [downloadloading, setdownloadLoading] = useState(false);
  const rowFileInputRef = useRef(null);

  console.log("data PQRImageUploadRenderer: ", data, filteredResult)

  const handleFile = useCallback(async (file, currentRowData) => {
    setLoading(true);
    
    try {
      // Validate file size
      const maxSize = 30 * 1024 * 1024;
      if (file.size > maxSize) {
        showWarning("File size exceeds the allowed limit. upto 30Mb is Allowed");
        return;
      }

      // Validate file type
      const ext = file.name.split(".").pop().toLowerCase();
      const allowed = ["pdf", "xlsx", "xls"];
      if (!allowed.includes(ext)) {
        showWarning("Only PDF and Excel (.pdf, .xlsx, .xls) files allowed");
        return;
      }

      // Use original filename (no renaming)
      const originalFile = file;
      setProfile(originalFile);

      // Existing file check
      const hasExistingFile = currentRowData.PQR_DocImage &&
                              currentRowData.PQR_DocImage !== "";
      if (hasExistingFile) {
        showWarning("File already exists. Delete first then upload.");
        return;
      }

      // File metadata prepare (same as training records)
      const fileMetadata = {
        PQR_DocImage: originalFile.name,
        PQR_DocImageOriginal: originalFile.name
      };

      const tempRowData = { ...currentRowData, ...fileMetadata };

      // Presigned URL from S3
      const presignedResult = await getPresignedURLForPQRRecord(
        currentRowData.wld_WPSType, 
        currentRowData.PQR_RecordNo || currentRowData.SK?.split("#")[1] || "PQR_doc", 
        originalFile.name
      );
      if (!presignedResult?.url) {
        showWarning("Failed to get upload URL.");
        return;
      }

      // S3 directly upload
      const s3Result = await axios.put(presignedResult.url, originalFile, {
        onUploadProgress: (progressEvent) => {
          const completed = Math.min(
            100,
            Math.round((progressEvent.loaded / progressEvent.total) * 100)
          );
          setProgress(completed);
        }
      });

      if (s3Result) {
        // DB metadata save - include required key fields
        const uploadResult = await UpdatePQRHeader({
          Wld_createdon_year: tempRowData.Wld_createdon_year,
          wld_WPSType: tempRowData.wld_WPSType,
          PQR_RecordNo: tempRowData.PQR_RecordNo,
          PQR_DocImage: tempRowData.PQR_DocImage,
          PQR_DocImageOriginal: tempRowData.PQR_DocImageOriginal
        });

        if (uploadResult?.message === "Success") {
          // Grid update - use SK for unique identification
          setFilteredResult(prev =>
            prev.map(record =>
              record.SK === currentRowData.SK
                ? {
                    ...record,
                    PQR_DocImage: tempRowData.PQR_DocImage,
                    PQR_DocImageOriginal: tempRowData.PQR_DocImageOriginal
                  }
                : record
            )
          );
          showSuccess("File uploaded successfully!");
        } else {
          showWarning("File upload failed");
        }
        setProgress(0);
      }
    } catch (error) {
      console.error("Upload error:", error);
      showWarning("File upload failed. Please try again.");
    } finally {
      setLoading(false);
    }
  }, [setLoading, setFilteredResult]);

  // Download
  const handleDownload = useCallback(async (currentRowData) => {
    const result = await getPresignedURLForPQRRecord(
      currentRowData.wld_WPSType, 
      currentRowData.PQR_RecordNo || currentRowData.SK?.split("#")[1] || "PQR_doc", 
      currentRowData.PQR_DocImage
    );
    setdownloadLoading(true);
    fetch(result.url)
      .then(res => res.blob())
      .then(blob => {
        const url = window.URL.createObjectURL(blob);
        const anchor = document.createElement("a");
        anchor.href = url;
        anchor.target = "_blank";
        anchor.download = currentRowData.PQR_DocImageOriginal;
        anchor.click();
        window.URL.revokeObjectURL(url);
        setdownloadLoading(false);
      })
      .catch(err => console.error("Download error:", err));
  }, []);

  // Delete
  const handleDeleteFile = useCallback(async (currentRowData) => {
    setLoading(true);
    try {
      // DB update - include required key fields
      const updatedData = {
        Wld_createdon_year: currentRowData.Wld_createdon_year,
        wld_WPSType: currentRowData.wld_WPSType,
        PQR_RecordNo: currentRowData.PQR_RecordNo,
        PQR_DocImageOriginal: "",
        PQR_DocImage: ""
      };
      const dbResult = await UpdatePQRHeader(updatedData);

      if (dbResult?.message === "Success") {
        // Grid update - use SK for unique identification
        setFilteredResult(prev =>
          prev.map(record =>
            record.SK === currentRowData.SK
              ? { ...record, PQR_DocImage: "", PQR_DocImageOriginal: "" }
              : record
          )
        );

        // S3 file delete
        const filepath = `wld_Images/PQR`;
        await deletePQRFile(filepath, currentRowData.PQR_DocImage);
        showSuccess("File deleted successfully.");
        setDeleteCounter(prev => prev + 1);
      } else {
        showWarning("Failed to update record.");
        return;
      }
    } catch (error) {
      showWarning("File deletion failed.");
    } finally {
      setLoading(false);
    }
  }, [setLoading, setFilteredResult]);

  return (
    <ImageUploadRenderer
      Imgloading={Imgloading}
      downloadloading={downloadloading}
      key={`pqr-upload-${data.SK}-${deleteCounter}`}
      progress={progress}
      profileOg={data.PQR_DocImageOriginal || ""}
      id={`fileUpload_${data.SK}`}
      name="fileInput"
      type="file"
      accept="application/pdf,.xlsx,.xls"
      size={30}
      selectedData={{ data }}
      handleFile={(e) => {
        if (e.target.files[0]) handleFile(e.target.files[0], data);
      }}
      handleDownload={() => handleDownload(data)}
      handleDelete={() => handleDeleteFile(data)}
    />
  );
};










const PQRGroove_Overlay = forwardRef((props, ref) => {
  const [rowData, setRowData] = useState({});
  const [Imgloading, setImgLoading] = useState(false);
  const [filteredResult, setFilteredResult] = useState([]);
  const [columnDefs, setColumnDefs] = useState([]);
  const [Groove, setGroove] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [showExcelForm, setShowExcelForm] = useState(false);
  const [action, setAction] = useState("");
  const [reload, setReload] = useState(false);
  const navigate = useNavigate();
  let Band = sessionStorage.getItem("Band");
  let userprofile = sessionStorage.getItem("UserProfile");
  const [WPStype] = useState(props.type);
  const [userObj, setuserObj] = useState("");
  const [loading, setLoading] = useState(true);
  const childRef = useRef();
  const year = new Date().getFullYear();

  const tmpcolumnDefs = useMemo(() => {
    return WPStype === "Tubesheet" ? TUBESHEET_COLUMNS : GROOVE_OVERLAY_COLUMNS;
  }, [WPStype]);

  const headerName = (field) => {
    let name = getHeader_FieldName(field, tmpcolumnDefs, "getHeader");
    return name;
  };

  const fieldName = (header) => {
    let name = getHeader_FieldName(header, tmpcolumnDefs, "getField");
    return name;
  };

  const fetchGroove = async () => {
    const startYear = parseInt(process.env.REACT_APP_START_YEAR) || 2023;
    const currentYear = new Date().getFullYear();
    
    setLoading(true);

    try {
      // Create array of years in descending order
      const years = [];
      for (let year = currentYear; year >= startYear; year--) {
        years.push(year);
      }

      // Fetch all years in parallel
      const promises = years.map(year => {
        const gridParameter = {
          type: WPStype,
          band: sessionStorage.getItem("Band"),
          user: sessionStorage.getItem("User"),
          year: year,
        };
        return getGridHeaderData(gridParameter);
      });

      const results = await Promise.all(promises);
      
      // Combine results maintaining year order
      const allResults = results.flat().filter(Boolean);
      
      console.log("PQRData", allResults);
      setGroove(allResults);
      setFilteredResult(allResults);

    } catch (error) {
      console.error("Error fetching PQR data:", error);
    } finally {
      setLoading(false);
    }
  };

  const actionRenderer = (params) => (
    <UnifiedActionRenderer
      actions={['delete', 'edit', 'export', 'copy', 'temp', 'excel']}
      selectedData={params}
      handleEditEvent={(params) => handleClickedit(params.data)}
      handlePdfEvent={(params) => handlepdf(params.data)}
      handleExcelEvent={(params) => handleExcel(params.data)}
      handleDeleteEvent={(params) => handleDeleteEvent(params.data)}
      handleCopyEvent={(params) => handleClickcopy(params.data)}
    //handleTempEvent={(params) => handleClickTemp(params.data)}
    />
  );

  

  const folderpqr = WPStype === "Tubesheet"
    ? "PQR_Tubesheet"
    : "PQR_GrooveOverlay";

    const imageRenderer = (params) => (
        <PQRImageUploadRenderer
          data={params.data}
          folderpqr={folderpqr}
          Imgloading={Imgloading}
          setLoading={setLoading}
          filteredResult={filteredResult}
          setFilteredResult={setFilteredResult}
        />
      );

  const fetchColumnDefns = useMemo(() => {
    return () => {
      
      const result = GlobalColumnDefinations(tmpcolumnDefs);
      result.push({
        headerName: "PQR Documents",
        field: "PQR_DocImageOriginal",
        cellRenderer: imageRenderer,
        minWidth: 250,
      });
      result.push({
        headerName: "",
        cellRenderer: actionRenderer,
        minWidth: 250,
        suppressMenu: true,
        sortable: false,
      });
      setColumnDefs(result);
    };
  });



    



  useEffect(() => {
    fetchGroove();
    fetchColumnDefns();
  }, []);

  function handleClick() {
    if (WPStype === "Groove") {
      navigate("/pqr/Groove/Groovetrans", {
        state: { data: "", action: "Add", WPStype: WPStype },
      });
    } else if (WPStype === "Overlay") {
      navigate("/pqr/Overlay/Overlaytrans", {
        state: { data: "", action: "Add", WPStype: WPStype },
      });
    } else if (WPStype === "Tubesheet") {
      navigate("/pqr/TubetoTubesheet/TubetoTubesheettrans", {
        state: { data: "", action: "Add", WPStype: WPStype },
      });
    }
  }

  function handleClickedit(row) {

    if (row.WPSH_Status === "Approved") {
      row.WPS_Change_No = String(Number(row.WPS_Change_No) + 1);
    }

    if (WPStype === "Groove") {
      navigate("/pqr/Groove/Groovetrans", {
        state: {
          data: row,
          action: "Edit",
          WPStype: WPStype,
          WPS_Change_No: row.WPS_Change_No,
        },
      });
    } else if (WPStype === "Overlay") {
      navigate("/pqr/Overlay/Overlaytrans", {
        state: {
          data: row,
          action: "Edit",
          WPStype: WPStype,
          WPS_Change_No: row.WPS_Change_No,
        },
      });
    } else if (WPStype === "Tubesheet") {
      navigate("/pqr/TubetoTubesheet/TubetoTubesheettrans", {
        state: {
          data: row,
          action: "Edit",
          WPStype: WPStype,
          WPS_Change_No: row.WPS_Change_No,
        },
      });
    }
  }

  function handleClickcopy(row) {

    if (WPStype == "Tubesheet") {
      navigate("/pqr/TubetoTubesheet/TubetoTubesheettrans", {
        state: { data: row, action: "Copy", WPStype: WPStype },
      });
    }
    else if (WPStype == "Overlay") {
      navigate("/pqr/Overlay/Overlaytrans", {
        state: { data: row, action: "Copy", WPStype: WPStype },
      });
    }
    else if (WPStype == "Groove") {
      navigate("/pqr/Groove/Groovetrans", {
        state: { data: row, action: "Copy", WPStype: WPStype },
      });
    }

  }

  useImperativeHandle(ref, () => ({
    handleAdd: () => {
      handleClick();
    },
  }));




  const handleGlobalSearch = (text) => {
    childRef.current.setSearch(text);
  };

  const handleGlobalExport = () => {
    if (WPStype === "Groove") {
      let filename = "PQRGrooveTransaction";
      handleExport1(filteredResult, filename, columnDefs);
    } else if (WPStype === "Overlay") {
      let filename = "PQROverlayTransaction";
      handleExport1(filteredResult, filename, columnDefs);
    }
  };


  const handlepdf = (row) => {
    if (row?.WPSH_Status === "Freezed") {

      setAction("pdf");
      setRowData(row);
      setShowForm(true);
      setuserObj(userprofile);
    }
    else {
      alert("Cannot Print PDF.Please Approve the Record")

    };
  }

  const handleExcel = (row) => {
    if (row?.WPSH_Status === "Freezed") {
      setAction("excel");
      setRowData(row);
      setShowExcelForm(true);
      setuserObj(userprofile);
    }
    else {
      alert("Cannot Export Excel. Please Approve the Record");
    }
  };


  const handleDeleteEvent = async (row) => {
    try {
      setRowData(row);
      let gridDetail = {
        PK: row.PK,
        SK: row.SK,
        WPSH_PQR_Process: row.WPSH_PQR_Process,
        WPSH_PQR_Type: row.WPSH_PQR_Type,
        WPStype: WPStype
      };
      await DeletePQR(gridDetail);
      showSuccess(`Selected Detail Grid is Deleted`);
    } catch (error) {
      console.error("Error deleting PQR record:", error);
      alert("Failed to delete the record. Please try again.");
    }
  };



  return (
    <Container fluid>
      <Row className="RowHeight">
        <Col md={2} sm={12} xs={12} className="ListTitle">
          PQR {WPStype === "Tubesheet" ? "Tube to Tubesheet" : WPStype} list
        </Col>
        <Col>
          <div className="global-search-container">
            <GolbalSearch
              searchplaceholdertext={
                "Search for " +
                WPStype +
                " WelderId, Welder Name ,Record No. , Revision No."
              }
              withYear={false}
              filterFunc={handleGlobalSearch}
            />
            <img
              className="allexport"
              src={ICONS.Export}
              alt="Export"
              onClick={handleGlobalExport}
            />
          </div>
        </Col>
      </Row>
      {loading && (
        <BarLoader height={5} width={195} className="gridloader" />
      )}
      <GridMaster
        rowDetails={filteredResult}
        colDetails={columnDefs}
        fieldNames={fieldName}
        headerNames={headerName}
        paginationPageSize={6}
        ref={childRef}
      />
      {showForm && (
        <Pdf_DownloadPQR
          show={showForm}
          action={action}
          rowdata={rowData}
          onHide={() => setShowForm(false)}
          fetchUserMaster={fetchGroove}
          setReload={setReload}
          reload={reload}
          userObj={userObj}
          allRecs={Groove}
          backdrop="static"
          Band={Band}
        />
      )}
      {showExcelForm && WPStype === "Tubesheet" && (
        <Excel_DownloadPQR_Tubesheet
          show={showExcelForm}
          action={action}
          rowdata={rowData}
          onHide={() => setShowExcelForm(false)}
          fetchUserMaster={fetchGroove}
          setReload={setReload}
          reload={reload}
          userObj={userObj}
          allRecs={Groove}
          backdrop="static"
          Band={Band}
        />
      )}
      {showExcelForm && (WPStype === "Groove" || WPStype === "Overlay") && (
        <Excel_DownloadPQR_GrooveOverlay
          show={showExcelForm}
          action={action}
          rowdata={rowData}
          onHide={() => setShowExcelForm(false)}
          fetchUserMaster={fetchGroove}
          setReload={setReload}
          reload={reload}
          userObj={userObj}
          allRecs={Groove}
          backdrop="static"
          Band={Band}
        />
      )}
      <Toaster />
    </Container>
  );
});

export default PQRGroove_Overlay;
